import {
  POS_CUSTOM_ITEMS_LOADING,
  POS_CUSTOM_ITEMS_LIST,
  POS_CUSTOM_ITEMS_ERROR,
} from "./actionTypes";

const initialState = {
  items: [],
  loading: false,
  loaded: false,
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_CUSTOM_ITEMS_LOADING:
      return { ...state, loading: true, error: null };

    case POS_CUSTOM_ITEMS_LIST:
      return {
        ...state,
        items: action.payload || [],
        loading: false,
        loaded: true,
        error: null,
      };

    case POS_CUSTOM_ITEMS_ERROR:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
